import './scss/global.scss';
import './controle_menu_login.js';
import './font_resize.js';
import './controle_menu_mobile.js';
import Vue from 'vue';

//Bootstrap
import Modal from './bootstrap-5.2.2/js/src/modal';
import Alert from './bootstrap-5.2.2/js/src/alert';
import Popover from './bootstrap-5.2.2/js/src/popover';
import Carousel from './bootstrap-5.2.2/js/src/carousel';
import Tooltip from './bootstrap-5.2.2/js/src/tooltip';

window.bootstrap = { Modal, Alert, Popover, Carousel, Tooltip };
